import { api } from '../../AxiosConfig';

class LembretesService {
    create(data: any) {
        return api.post('/lembretes/create', data);
    }

    findAll() {
        return api.get('/lembretes/findAll');
    }

    findOne(id: string) {
        return api.post('/lembretes/findOne', { id });
    }

    previewTargets(data: { targetClientIds?: string[]; targetGroupIds?: string[] }) {
        return api.post('/lembretes/preview-targets', data);
    }

    update(id: string, update: any) {
        return api.post('/lembretes/update', { id, update });
    }

    delete(id: string) {
        return api.post('/lembretes/delete', { id });
    }
}

export default new LembretesService();
